import React, { useState } from "react";
import { Link } from "react-router-dom";
import Admissionleft from "./Admissoinleft";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import Fade from "react-bootstrap/Fade";

function MsPhdInternational_admissionEle() {
    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    // const [categoryOpen, setCategoryOpen] = useState(false);
    const [areasOpen, setAreasOpen] = useState(false);
    const [eligiblityOpen, setEligiblityOpen] = useState(false);
    const [financialOpen, setFinancialOpen] = useState(false);
    // const [sectionOpen, setSectionOpen] = useState(false);
    // const [documentsOpen, setDocumentsOpen] = useState(false);
    const [feesOpen, setFeesOpen] = useState(false);
    const [applyonlineOpen, setApplyonlineOpen] = useState(false);

    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);
        // setCategoryOpen(false);
        setAreasOpen(false);
        setEligiblityOpen(false);
        setFinancialOpen(false);
        // setSectionOpen(false);
        // setDocumentsOpen(false);
        setFeesOpen(false);
        setApplyonlineOpen(false);
        event(true);
    };

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className="c-left custom-padding-color mb-5">
                        <Admissionleft activeIndex={6} />
                    </Col>

                    <Col md={8} className="c-right">
                        <div className="c-heading">
                            <h3>M.S. / Ph.D. International Admissions</h3> <br />
                        </div>

                        <Row className="mb-5">
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button"
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}
                                >
                                    Dates
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setGuidelinesOpen)
                                    }
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}
                                >
                                    Guidelines
                                </Button>
                            </Col>

                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setCategoryOpen)}
                                    aria-controls="c-categoryOpen"
                                    aria-expanded={categoryOpen}
                                >
                                    Categories
                                </Button>
                            </Col> */}

                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setAreasOpen)}
                                    aria-controls="c-areas"
                                    aria-expanded={areasOpen}
                                >
                                    Areas
                                </Button>
                            </Col> */}

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setEligiblityOpen)
                                    }
                                    aria-controls="c-eligiblity"
                                    aria-expanded={eligiblityOpen}
                                >
                                    Eligiblity
                                </Button>
                            </Col>

                         
                            {/* section */}
                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setSectionOpen)}
                                    aria-controls="c-fiancial"
                                    aria-expanded={sectionOpen}
                                >
                                    Selection
                                </Button>
                            </Col> */}
                            {/* Documents */}
                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setDocumentsOpen)
                                    }
                                    aria-controls="c-document"
                                    aria-expanded={documentsOpen}
                                >
                                    Documents
                                </Button>
                            </Col> */}

                            {/* Fees */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setFeesOpen)}
                                    aria-controls="c-feesopen"
                                    aria-expanded={feesOpen}
                                >
                                    Fees
                                </Button>
                            </Col>


                            {/* financial */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setFinancialOpen)
                                    }
                                    aria-controls="c-financial"
                                    aria-expanded={financialOpen}
                                >
                                    Financial Assistance
                                </Button>
                            </Col>


                            {/* Apply Online */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setApplyonlineOpen)
                                    }
                                    aria-controls="c-applyonline"
                                    aria-expanded={feesOpen}
                                >
                                    Apply Online
                                </Button>
                            </Col>
                        </Row>

                        {/*dates */}
                        <div>
                            {datesOpen && (
                                <Fade in={datesOpen}>
                                    <div>

                                        {/* <p className="fw-bold">Admission Brochure: <Link className="c-link" to="https://files.iittp.ac.in/pdfs/admissions/international/sep/OIAA_MS_PhDAdmission_Sep_2024_Brochure.pdf"> <span className="glowing-text">Click Here</span> </Link></p> */}
                                        {/* <a className="text-maroon glowing-text" href="https://files.iittp.ac.in/pdfs/admissions/international/MSPhD_Int_Flyer_3_2005.pdf" target="_blank;"><b>M.S. / Ph.D. International Admissions Brochure - Click here </b></a> <br /><br /> */}
                                        {/* <p className="fw-bold"> <span className="glowing-text">Admissions for January semester into MS and PhD program will be open in October and please watch this page regularly for updates</span> </p> */}
                                        <Table
                                            bordered
                                            responsive
                                            className="mt-3"
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        colSpan="2"
                                                        className="text-center"
                                                    >
                                                        <h4 className="text-primary">
                                                            Important Dates
                                                        </h4>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                    Admission Portal 
                                                    </td>
                                                    <td>
                                                        <b className="c-link glowing-text">Open</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                    Application Review Begins                                                    
                                                    </td>
                                                    <td>
                                                        <b className="c-link glowing-text">30 September 2026
                                                            <br />(For Semester starting in January 2027)
                                                        </b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                    Interview
                                                    </td>
                                                    <td>
                                                        <b className="c-link glowing-text">October - November 2026</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Announcement of Results</td>
                                                    <td>
                                                        <b className="c-link glowing-text">Within two weeks from the date of completion of the interview</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Result (July 2027 Intake)</td>
                                                    <td>
                                                        <b className="c-link glowing-text">To be announced</b>
                                                        {/*<b><Link className="c-link" target="_blank" to="https://files.iittp.ac.in/pdfs/admissions/international/MsPhDMtech-International-Jul2026_Intake_Results.pdf">Click Here</Link></b>*/}
                                                    </td>
                                                </tr>
                                                {/* <tr>
                                                    <td>
                                                    Admission Portal 
                                                    </td>
                                                    <td>
                                                        <b>Open</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                    Application Review Begins                                                    
                                                    </td>
                                                    <td>
                                                        <b>October 2025
                                                            <br />(For Semester starting in January 2026)
                                                        </b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                    Interview
                                                    </td>
                                                    <td>
                                                        <b>	November 2025</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Announcement of Results</td>
                                                    <td>
                                                        <b>Within two weeks from the date of completion of the interview</b>
                                                    </td>
                                                </tr> */}
                                                {/* <tr>
                                                    <td>Orientation Program</td>
                                                    <td>
                                                        <b>Friday, July 26, 2024</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Commencement of classes
                                                    </td>
                                                    <td>
                                                        <b>Thursday, August 1, 2024</b>
                                                    </td>
                                                </tr>*/}
                                            </tbody>
                                        </Table>

                                        <b>
                                         Please write to{" "}
                                            <Link to="mailto:gac_office@iittp.ac.in" className="c-link"> gac_office@iittp.ac.in </Link>{" "} or WhatsApp/ mobile at  +91 90300 38191/ 8333 904 912 for any questions or queries regarding admission related matters. {" "} </b>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Guidelines*/}

                        <div>
                            {guidelinesOpen && (
                                <Fade in={guidelinesOpen}>
                                    <div className="c-lineheight2dot5">
                                        <h4 className="mb-3">
                                            Important Guidelines:
                                        </h4>

                                        <ol
                                            style={{
                                                textAlign: "justify",
                                                fontSize: "12pt",
                                            }}
                                        >
                                            <li>
                                               1. The link to the online application form is available under the Apply Online tab. After completing the online form, please save it for your record.
                                            </li>
                                            <li>
                                            2.	You can apply to a maximum of three departments.
                                            </li>
                                            <li>
                                            3.	The following documents must be uploaded before submitting your application. Each document must be less than 1MB.
                                            </li>
                                            
                                            <li>
                                              
                                                <ul className="myulcustarrow">
                                                    <li> A copy of passport or any government-issued identity document (as applicable) </li>
                                                    <li> Passport size Photo (jpg, jpeg, png). </li>
                                                    <li> Signature (format jpg, jpeg, png). </li>
                                                    <li> School leaving certificate (pdf). </li>
                                                    <li> UG Degree Certificate (pdf). </li>
                                                    <li> Consolidated UG transcript (pdf). </li>
                                                    <li> PG Degree Certificate (if applicable) (pdf). </li>
                                                    <li> Consolidated PG transcript (pdf). </li>
                                                    <li> Statement of Purpose/Research Proposal, (pdf). </li>
                                                    {/* <li> First page of publication, (if applicable) (pdf, jpg, jpeg) each size &lt;= 1024 KB </li> */}

                                                </ul>
                                            </li>
                                            {/* <li>
                                              4. In case of any queries, you may reach us at{" "}
                                                <a href="mailto:ia_office@iittp.ac.in">
                                                    ia_office@iittp.ac.in
                                                </a>
                                                 or WhatsApp/ mobile at +91 90300 38191.
                                            </li> */}
                                        </ol>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Categoies*/}

                        {/* <div>
                            {categoryOpen && (
                                <Fade in={categoryOpen}>
                                    <div className="c-lineheight2dot5">
                                        <h4 className="mb-3">
                                            Ph.D admissions are made under two
                                            categories
                                        </h4>

                                        <li>
                                            1. Regular (Full-time scholars): The
                                            research scholars selected under
                                            regular registration will be
                                            eligible for assistantship through
                                            various schemes (please see
                                            Financial Assistance)
                                        </li>
                                        <li>
                                            External:
                                            <ul className="myulcustarrow">
                                                <li>
                                                    The applicants must be
                                                    regular employees and have
                                                    at least two years of work
                                                    experience.
                                                </li>
                                                <li>
                                                    They must be sponsored by
                                                    and employed in an
                                                    industry/organization/national
                                                    laboratories, having R&D
                                                    facilities and recognized by
                                                    DST or by IIT Tirupati.
                                                </li>
                                                <li>
                                                    Research scholars admitted
                                                    under this category will
                                                    normally carry out part or
                                                    all of their research in the
                                                    parent organization under
                                                    supervision of a faculty
                                                    from IIT Tirupati and a
                                                    co-supervisor employed in
                                                    their parent organization.
                                                </li>
                                            </ul>
                                        </li>

                                        <ul className="myulcustarrow">
                                            <li>
                                                The following documents are
                                                required along with the
                                                application{" "}
                                            </li>
                                        </ul>

                                        <ol className="myulcustdisc">
                                            <li>
                                                Proof of employment (Identity
                                                Card or latest salary statement)
                                            </li>
                                            <li>
                                                No-Objection Certificate or
                                                Undertaking (format available at
                                                this{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/3.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                                )
                                            </li>
                                        </ol>

                                        <ul className="myulcustarrow">
                                            <li>
                                                The following documents are
                                                required at the time of
                                                admission
                                            </li>
                                        </ul>

                                        <ol className="myulcustdisc">
                                            <li>
                                                Certificate of Support from the
                                                Employer:{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/4.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                            </li>
                                            <li>
                                                Relieving Certificate from the
                                                Employer:{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/5.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                            </li>
                                        </ol>

                                        <ul className="myulcustarrow">
                                            <li>
                                                More details on this category of
                                                admission, including any
                                                questions regarding the
                                                recognition of the
                                                organization/laboratory might be
                                                addressed to the Head of the
                                                department of interest or{" "}
                                                <Link
                                                    to="mailto:admissions@iittp.ac.in"
                                                    className="c-link"
                                                >
                                                    admissions@iittp.ac.in
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </Fade>
                            )}
                        </div> */}

                        {/*Areas*/}

                        <div>
                            {areasOpen && (
                                <Fade in={areasOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Research Areas (For MS)
                                        </h4>
                                        

                                       {/* Table */}
                                    <Table bordered responsive className="mt-3 c-table">
                                        <colgroup>
                                            <col style={{ width: '20%' }} /> {/* 33% for each column */}
                                            <col style={{ width: '40%' }} />
                                            <col style={{ width: '40%' }} />
                                        </colgroup>
                                        <tbody>
                                            {/* Table header */}
                                            <tr>
                                                <td><b>Department<img src="/result_htm_f6dcee4dfa07852d.png" width="14" height="14" hspace="54" vspace="15" /></b></td>
                                                <td><b>Division</b></td>
                                                <td ><b>Areas of Research</b></td>
                                            </tr>
                                            {/* Table rows */}
                                            {/* Row 1 */}
                                            <tr>
                                                <td>Chemical Engineering</td>
                                                <td >Chemical Engineering</td>
                                                <td >Nanobiotechnology, Process Control and Optimization, Machine Learning for Nanomaterials, Computer Vision for Process Engineering, Production and Distribution Optimization, Biomass to Chemicals/Fuel, Materials for Li-Ion and Na-Ion Batteries, Catalytic Conversion of Co2 to Fuel, Granular Flow, Theoretical Fluid Mechanics, Membrane Science, Food Science and Technology, Microfluidics, General Chemical Engineering, Molecular simulations for energy materials, Molecular simulations for soft matter and interfaces. </td>
                                            </tr>
                                            {/* Row 2 */}
                                                <tr>                                             
                                                <td rowspan="6" className='c-table-rowspan-align'>Civil and Environmental Engineering</td>
                                                    <td>Environmental Engineering</td>
                                                    <td>Environmental Engineering</td>
                                                </tr>
                                                <tr>
                                                    <td>Geoinformatics and Remote Sensing</td>
                                                    <td>Geoinformatics and Remote Sensing</td>
                                                </tr>

                                                <tr>
                                                    <td>Geotechnical Engineering</td>
                                                    <td>Geotechnical Engineering</td>
                                                </tr>

                                                <tr>
                                                    <td>Structural Engineering</td>
                                                    <td>Structural Engineering</td>
                                                </tr>

                                                <tr>
                                                    <td>Transportation Engineering</td>
                                                    <td>Transportation Engineering</td>
                                                </tr>
                                                <tr>
                                                    <td>Water Resources Engineering</td>
                                                    <td>Water Resources Engineering</td>
                                                </tr>
                                        
                                           
                                          
                                        
                                            {/* Row 3 */}
                                            <tr>
                                                <td rowSpan="3" >
                                                    Computer Science and
                                                    Engineering
                                                </td>
                                                <td>
                                                    Algorithm and Architecture
                                                </td>
                                                <td>
                                                Parallel Computing, High Performance Computing, Graph Analytics, Algorithms and Data Structures, Algorithms and Computational Complexity, Architecture and Processor Design, AI Accelerator/Hardware, VLSI Testing and Verification
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Learning Systems
                                                </td>
                                                <td>
                                                AI + Software Engineering, Software Systems, Computing for Education, Human-Computer Interaction, Reinforcement Learning, Data Science Algorithms and Applications,Adversarial Deep Learning, Federated Learning, Deep learning for Edge Devices, Deep Reinforcement Learning, Deep Learning, Stochastic Approximation Algorithms , Multi Agent Systems, Emergent Communication 
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Intelligent Networks
                                                </td>
                                                <td>
                                                Computer Networks, Internet of Things, Machine Learning for IoTs, AI for Cybersecuirty
                                                </td>

                                            </tr>

                                            {/* Row 4 */}
                                            <tr>
                                                <td rowSpan="4" >
                                                    Electrical Engineering
                                                </td>

                                                <td>Power and Control</td>
                                                <td>
                                                Control and Robotics, Power Electronics, Smart Power Grids
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    Signal Processing & Communications
                                                </td>
                                                <td>
                                                Computer Vision, Deep Learning and Medial Imaging, Next Generation Wireless Communication and Networks
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Electronics</td>
                                                <td>Digital VLSI Design and Processor Architecture, Electronic Devices and Circuits, Electronic Instrumentation</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    RF & Microwave
                                                </td>
                                                <td>
                                                Applied Electromagnetics, RF Sensors and Metamaterials, Antenna System Architecture
                                                </td>
                                            </tr>

                                           
                                            {/* Row 5 */}
                                            <tr>
                                                <td rowSpan="5" >
                                                    Mechanical Engineering
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    Advance Manufacturing
                                                </td>
                                                <td>
                                                Smart CNC Machine Tools, 4D Printing, Digital twin for metal additive manufacturing, Distortion control in ship buidling structures, Robotics in large-scale welding , Functionally graded materials manufacturing using twin wire arc additive manufacturing, Composite Filaments for 3D Printing, 3D Printing of Composite Structures, Advanced Manufacturing Processes
                                                </td>
                                            </tr>


                                            <tr>
                                                <td>Fluids and Thermal Engineering</td>
                                                <td>Fluid mechanics, Low speed aerodynamics, Wind tubrines,Drones, Energy storage ,Combustion, Heat transfer, High-speed combustion modelling, Hydrodynamics, Waves in Fluids, Non-Newtonian Fluid Flow, Computational Fluid Dynamics (CFD)</td>
                                            </tr>


                                            <tr>
                                                <td>
                                                    Robotics and Mechatronics
                                                </td>
                                                <td>
                                                Autonomous underwater Robot Design and Control, AI assisted concrete 3D printing, Optimization in robotics, Nonlinear estimation and control
                                                </td>
                                            </tr>


                                            <tr>
                                                <td>Solid Mechanics and Design</td>
                                                <td>Vehicle dynamics, Automotive NVH, Fault detection, Digital twin for health monitoring, Experimental and theoretical biomechanics, Physics informed machine learning, Computational Solid Mechanics, Machine Learning in Mechanics</td>
                                            </tr>
                                            {/* End of table rows */}
                                        </tbody>
                                    </Table>
{/* Next table ------------------------------------------------------------------------------------------------- */}
                                        <h4 className="mb-4">
                                            Research Areas (For Ph.D.)
                                        </h4>
                                        {/* <p>
                                            Applicants are required to select
                                            the research areas in the online
                                            admission portal as per the
                                            availability in the respective
                                            category/scheme. The available
                                            research areas for July 2023
                                            admission cycle are tabulated below.
                                            For interdisciplinary research,
                                            applicants are encouraged to browse
                                            research areas offered by various
                                            departments. Interested candidates
                                            with degree in electrical /
                                            electronics and communications /
                                            computer science and engineering are
                                            encouraged to apply for Robotics and
                                            Mechatronics listed under Mechanical
                                            Engineering.
                                        </p> */}
                                         {/* Table */}
                                    <Table bordered responsive className='mt-3 c-table'>
                                        <colgroup>
                                            <col style={{ width: '20%' }} /> {/* 33% for each column */}
                                            <col style={{ width: '40%' }} />
                                            <col style={{ width: '40%' }} />
                                        </colgroup>
                                        <tbody>
                                            {/* Table header */}
                                            <tr>
                                                <td><b>Department<img src="/result_htm_f6dcee4dfa07852d.png" width="14" height="14" hspace="54" vspace="15" /></b></td>
                                                <td><b>Division</b></td>
                                                <td ><b>Areas of Research</b></td>
                                            </tr>
                                            {/* Table rows */}
                                            {/* Row 1 */}
                                            <tr>
                                                <td>Chemical Engineering</td>
                                                <td>Chemical Engineering</td>
                                                <td>Nanobiotechnology, Process Control and Optimization, Machine Learning for Nanomaterials, Computer Vision for Process Engineering, Production and Distribution Optimization, Biomass to Chemicals/Fuel, Materials for Li-Ion and Na-Ion Batteries, Catalytic Conversion of Co2 to Fuel, Granular Flow, Theoretical Fluid Mechanics, Membrane Science, Food Science and Technology, Microfluidics, General Chemical Engineering, Molecular simulations for energy materials, Molecular simulations for soft matter and interfaces.</td>
                                            </tr>

                                            {/* Row 6 */}
                                            <tr>
                                                <td rowspan="6" className='c-table-rowspan-align'>Chemistry</td>
                                                <td>Physical Chemistry</td>
                                                <td>Fluorescence Spectroscopy and Microscopy, Biophysical Chemistry, Chemical Biology</td>
                                            </tr>
                                            <tr>
                                                <td>Computational and Theoretical Chemistryy</td>
                                                <td>Theoretical investigation of sea-water desalination, Theoretical spectroscopy of aqueous osmolytes, Computational biophysics. </td>
                                            </tr>
                                            <tr>
                                                <td>Theoretical Chemistry</td>
                                                <td>Quantum Chemistry,Modelling Light-Matter Interactions,Stochastic Thermodynamics, Active matters,Theoretical Biophysical Chemistry, Active matters</td>
                                            </tr>

                                            <tr>
                                                <td>Organic Chemistry</td>
                                                <td>	Asymmetric total synthesis of bioactive natural products, <em>*Organic Synthesis: C-H Activation, Photocatalysis, Electrochemical Organic Synthesis, *Total Synthesis, Carbohydrate chemistry, Synthestic Vaccines and adjuvants</em>, Organic Synthesis, Alternative solvent to TCE, Transition Metal Catalysis, Asymmetric Catalysis, Organomatallic Catalysis, Photo Chemistry</td>
                                            </tr>

                                            <tr>
                                                <td>Inorganic Chemistry</td>
                                                <td>Polyoxometalate chemistry, Supramolecular Chemistry, Surface activation, Interlocked molecules, Energy storage, Waste-water treatment, Synthetic inorganic and bioinorganic chemistry</td>
                                            </tr>

                                            <tr>
                                                <td>Organic & Inorganic Chemistry</td>
                                                <td>Chemical Biology, Environmental Chemistry, Bioorganic and Bioinorganic Chemistry, Medicinal Chemistry</td>
                                            </tr>

                                            {/* Row 2 */}
                                            <tr>
                                                <td rowSpan="6" >
                                                    Civil and Environmental
                                                    Engineering
                                                </td>

                                                <td>
                                                    Environmental Engineering
                                                </td>
                                                <td>
                                                    Environmental Engineering
                                                </td>

                                            </tr>

                                            <tr>

                                                <td>
                                                    Geoinformatics  and Remote Sensing
                                                </td>
                                                <td>
                                                    Geoinformatics  and Remote Sensing
                                                </td>


                                            </tr>

                                            <tr>

                                                <td>
                                                    Geotechnical Engineering
                                                </td>
                                                <td>
                                                    Geotechnical Engineering
                                                </td>

                                            </tr>

                                            <tr>
                                                <td>
                                                    Structural Engineering
                                                </td>
                                                <td>Structural Engineering</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    Transportation Engineering
                                                </td>
                                                <td>
                                                    Transportation Engineering
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Water Resources Engineering
                                                </td>
                                                <td>
                                                    Water Resources Engineering
                                                </td>
                                            </tr>


                                            {/* Row 3 */}
                                            <tr>
                                                <td rowSpan="3" >
                                                    Computer Science and
                                                    Engineering
                                                </td>
                                                <td>
                                                    Algorithm and Architecture
                                                </td>
                                                <td>
                                                Parallel Computing, High Performance Computing, Graph Analytics, Algorithms and Data Structures, Algorithms and Computational Complexity, Architecture and Processor Design, AI Accelerator/Hardware, VLSI Testing and Verification
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Learning Systems
                                                </td>
                                                <td>
                                                AI + Software Engineering, Software SystemsComputing for Education, Human-Computer Interaction, Reinforcement Learning, Data Science Algorithms and Applications,Adversarial Deep Learning, Federated Learning, Deep learning for Edge Devices, Deep Reinforcement Learning Deep Learning, Multi Agent Systems 
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Intelligent Networks
                                                </td>
                                                <td>
                                                Computer Networks, Internet of Things, Machine Learning for IoTs, AI for Cybersecuirty
                                                </td>

                                            </tr>

                                            {/* Row 4 */}
                                            <tr>
                                                <td rowSpan="4" >
                                                    Electrical Engineering
                                                </td>

                                                <td>Power and Control</td>
                                                <td>
                                                Control and Robotics, Power Electronics, Smart Power Grids
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    Signal Processing & Communications
                                                </td>
                                                <td>
                                                Computer Vision, Deep Learning and Medial Imaging, Next Generation Wireless Communication and Networks
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Electronics</td>
                                                <td>Digital VLSI Design and Processor Architecture, Electronic Devices and Circuits, Electronic Instrumentation</td>
                                            </tr>
                                      
                                            <tr>
                                                <td>
                                                    RF & Microwave
                                                </td>
                                                <td>
                                                Applied Electromagnetics, RF Sensors and Metamaterials, Antenna System Architecture
                                                </td>
                                            </tr>


                                            {/* Row 9 */}
                                            <tr>
                                                <td rowSpan="6" >Humanities and Social Sciences</td>
                                            </tr>
                                            <tr>
                                                <td>Organizational Behavior/HRM</td>
                                                <td>
                                                Sustainable HRM, Decent Work and positive work outcomes, Positive Organizational Behavior, Strategic HRM and Organziational Performance, Academic Leadership.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Operations Management/Industrial Engineering</td>
                                                <td>
                                                Supply Chain Management, Reliability Engineering & Maintenance Management, Production Planning & Control, Project Management, Applications of Operations Research, Statistics and Machine Learning in Operations Management.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Economics</td>
                                                <td>
                                                Climate Change Economics, Disaster Management, Environmental Economics, Development Economics, Political Economy, Applied Econometrics and Machine Learning.</td>
                                            </tr>

                                            <tr>
                                                <td>English</td>
                                                <td>
                                                Indian Poetics, Comparative Literary Studies, Environmental Humanities.
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Philosophy</td>
                                                <td>
                                                Modern Indian Philosophy, Social and Political Philosophy, Moral Philosophy.
                                                </td>
                                            </tr>


                                            {/* Row 8 */}
                                            <tr>
                                                <td rowspan="2" className='c-table-rowspan-align'>Mathematics and Statistics</td>
                                                <td>Mathematics</td>
                                                <td>	
                                                Partial Differential Equations, Inverse Problems, Metric Fixed Point Theory, Numerical Analysis, Meshfree Methods, Computational Fluid Dynamics, GPU Computing, Fractals.
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Statistics</td>
                                                <td>Non-parametric Statistics, Multivariate Statistics, Biostatistics, Geospatial Statistics, Time Series Analysis, Machine Learning, Reliability and Survival Analysis, Causal Inference, Spatial-Temporal Models, Generalized Linear Models.</td>
                                            </tr>



                                            {/* Row 5 */}
                                            <tr>
                                                <td rowspan="4" valign="middle">Mechanical Engineering</td>
                                                <td>Advance Manufacturing</td>
                                                <td>Smart CNC Machine Tools, 4D Printing, Digital twin for metal additive manufacturing, Distortion control in ship buidling structures, Robotics in large-scale welding , Functionally graded materials manufacturing using twin wire arc additive manufacturing, Composite Filaments for 3D Printing, 3D Printing of Composite Structures, Advanced Manufacturing Processes</td>
                                            </tr>
                                            <tr>
                                                <td>Fluids and Thermal Engineering</td>
                                                <td>Fluid mechanics, Low speed aerodynamics, Wind tubrines,Drones, Energy storage ,Combustion, Heat transfer, High-speed combustion modelling, Hydrodynamics, Waves in Fluids, Non-Newtonian Fluid Flow, Computational Fluid Dynamics (CFD)</td>
                                            </tr>
                                            <tr>
                                                <td>Robotics and Mechatronics</td>
                                                <td>Autonomous underwater Robot Design and Control, AI assisted concrete 3D printing, Optimization in robotics, Nonlinear estimation and control</td>
                                            </tr>
                                            <tr>
                                                <td>Solid Mechanics and Design</td>
                                                <td>Vehicle dynamics, Automotive NVH, Fault detection, Digital twin for health monitoring, Experimental and theoretical biomechanics, Physics informed machine learning, Computational Solid Mechanics, Machine Learning in Mechanics</td>
                                            </tr>

                                           
                                        
                                            {/* Row 7 */}
                                            <tr>
                                                <td rowSpan="3" >Physics</td>
                                            </tr>
                                            <tr>
                                                <td>Theoretical Physics</td>
                                                <td>
                                                    <b>Astrophysics:</b> Astro particle physics, Cosmology, High energy phenomenology.<br />
                                                    <b>Ultrafast physics:</b> Theory of quantum dynamics at attosecond time scales, Theoretical atomic, molecular and optical physics, Computational physics.<br />
                                                    <b>AMO and Plasma Physics:</b> Relativistic Many body physics, Machine Learning based plasma modelling and diagnostics, Computational Atomic Physics, Relativistic calculations of electron atom processes.<br />
                                                    <b>Soft/condensed Matter Physics:</b> Computational soft matter physics, Ion trapping, Quantum many body physics, Relativistic Many body physics, Multiscale-modeling and machine learning in condensed matter and materials physics, Non-equilibrium statistical physics and Rheological characterization of glassy systems and complex fluids, Non-equilibrium systems.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Experimental Physics</td>
                                                <td>
                                                    <b>Spectroscopy and Experimental plasma Physics:</b> Time resolved imaging for plasma characterisation, Tunable diode laser absorption spectroscopy, Nonthermal plasma development and application in environmental remediation, Plasma-assisted material processing.<br />
                                                    <b>Quantum optics:</b> Precision laser spectroscopy, Laser cooling, Ion trapping, Ultracold atoms ions and molecules, cavity QED, quantum communication, portable atomic clocks and cavity ring down spectroscopy.
                                                </td>
                                            </tr>
                                        

                                         


                                            {/* End of table rows */}
                                        </tbody>
                                    </Table>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Eligiblity*/}

                        <div>
                            {eligiblityOpen && (
                                <Fade in={eligiblityOpen}>
                                    <div>
                                        <h4 className="mb-4">Eligibility</h4>
                                        {/* <Table
                                            bordered
                                            responsive
                                            className="mt-3"
                                        >
                                            <tbody>
                                                <tr>
                                                    <td colSpan="4">
                                                        <b>
                                                            Minimum
                                                            Qualifications for
                                                            Admission to the
                                                            Regular Ph.D program
                                                        </b>
                                                        Candidates applying for
                                                        the Ph.D program in one
                                                        of the following areas
                                                        need to have any one of
                                                        the minimum
                                                        qualifications mentioned
                                                        in the table below:
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td rowSpan="2">
                                                        <b>Area</b>
                                                    </td>
                                                    <td colSpan="3">
                                                        <b>
                                                            Minimum
                                                            Qualifications
                                                        </b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="65">
                                                        <b>S. No.</b>
                                                    </td>
                                                    <td>
                                                        <b>
                                                            Educational
                                                            Qualifications
                                                        </b>
                                                    </td>
                                                    <td>
                                                        <b>
                                                            Additional
                                                            Qualifying Exam
                                                        </b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        rowSpan="5"
                                                        height="422"
                                                    >
                                                        <b>Engineering</b>
                                                    </td>
                                                    <td>
                                                        <b>1</b>
                                                    </td>
                                                    <td>
                                                        • M.E / M.Tech / M.S by
                                                        Research in Engineering
                                                        / 5-year integrated
                                                        Masters/Dual Degree in
                                                        engineering.
                                                        <br />
                                                        • 2 year M.Sc from IITs
                                                        (entry through JAM) with
                                                        a minimum CGPA of 8 on a
                                                        10 point scale (7.5 for
                                                        EWS/OBC-NCL and 7.0 for
                                                        SC/ST/PwD) <br />•
                                                        B.S+M.S (5-year
                                                        integrated) from CFTI
                                                    </td>
                                                    <td>None</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <b>2</b>
                                                    </td>
                                                    <td>
                                                        • M.Sc degree holders in
                                                        the relevant discipline
                                                        from any recognized
                                                        university/institute are
                                                        eligible.
                                                    </td>
                                                    <td>
                                                        Valid GATE
                                                        score/UGC-NET/CSIR-NET/NBHM/Inspire
                                                        or equivalent
                                                        qualification tenable
                                                        for the year of
                                                        registration. In case of
                                                        candidates with more
                                                        than 5 years relevant
                                                        experience after the
                                                        M.Sc, the requirement of
                                                        a test score may be
                                                        waived by the selection
                                                        committee.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <b>
                                                            3<sup>#</sup>
                                                        </b>
                                                    </td>
                                                    <td>
                                                        B.S/B.E/B.Tech from a
                                                        Centrally Funded
                                                        Technical Institute
                                                        (CFTI) with a minimum
                                                        CGPA of 8.0 on a 10.0
                                                        point scale (7.5 for
                                                        EWS/OBC-NCL and 7.0 for
                                                        SC/ST/PwD)
                                                    </td>
                                                    <td>None</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <b>
                                                            4<sup>#</sup>
                                                        </b>
                                                    </td>
                                                    <td>
                                                        B.S/B.E/B.Tech from a
                                                        CFTI without minimum
                                                        CGPA 8.0 on a 10.0 point
                                                        scale (7.5 for
                                                        EWS/OBC-NCL and 7.0 for
                                                        SC/ST/PwD)
                                                    </td>
                                                    <td>Valid GATE score</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <b>
                                                            5<sup>#</sup>
                                                        </b>
                                                    </td>
                                                    <td>
                                                        BE/BTech from any other
                                                        university, with a
                                                        minimum CGPA of 8.0 on a
                                                        10.0 point scale (7.5
                                                        for EWS/OBC-NCL and 7.0
                                                        for SC/ST/PwD)
                                                    </td>
                                                    <td>Valid GATE score</td>
                                                </tr>
                                                <tr>
                                                    <td rowSpan="5">
                                                        <b>Sciences</b>
                                                    </td>
                                                    <td>
                                                        <b>6</b>
                                                    </td>
                                                    <td>
                                                        • M.E/M.Tech or M.S by
                                                        Research in engineering{" "}
                                                        <br />
                                                        • 2 year M.Sc from IITs
                                                        (entry through JAM) with
                                                        a minimum CGPA of 8.0 on
                                                        10.0 point scale (7.5
                                                        for EWS/OBC-NCL and 7.0
                                                        for SC/ST/PwD) <br />•
                                                        B.S+M.S, or 5-year
                                                        integrated degree from
                                                        CFTI
                                                    </td>
                                                    <td>None</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <b>7</b>
                                                    </td>
                                                    <td>
                                                        • M.Sc from IITs without
                                                        minimum CGPA 8.0 on a
                                                        10.0 point scale (7.5
                                                        for EWS/OBC-NCL and 7.0
                                                        for SC/ST/PwD)
                                                        <br />• M.Sc from
                                                        institutions other than
                                                        IITS
                                                    </td>
                                                    <td>
                                                        Valid GATE score/UGC-NET
                                                        fellowship/CSIR-NET
                                                        fellow-ship/NBHM Ph.D
                                                        scholarship or
                                                        equivalent
                                                        qualification, tenable
                                                        for the current year of
                                                        admission.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <b>
                                                            8<sup>#</sup>
                                                        </b>
                                                    </td>
                                                    <td>
                                                        B.S/B.E/B.Tech from a
                                                        Centrally Funded
                                                        Technical Institute
                                                        (CFTI) with a minimum
                                                        CGPA of 8 on 10 point
                                                        scale (7.5 for
                                                        EWS/OBC-NCL and 7.0 for
                                                        SC/ST/PwD).
                                                    </td>
                                                    <td>None</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <b>
                                                            9<sup>#</sup>
                                                        </b>
                                                    </td>
                                                    <td>
                                                        B.S/B.E/B.Tech from a
                                                        CFTI without minimum
                                                        CGPA 8 on a 10 point
                                                        scale (7.5 for
                                                        EWS/OBC-NCL and 7.0 for
                                                        SC/ST/PwD).
                                                    </td>
                                                    <td>Valid GATE score</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <b>
                                                            10<sup>#</sup>
                                                        </b>
                                                    </td>
                                                    <td>
                                                        B.E/BTech from any other
                                                        university, with a
                                                        minimum CGPA of 8.0 on a
                                                        10.0 point scale (7.5
                                                        for EWS/OBC-NCL and 7.0
                                                        for SC/ST/PwD)
                                                    </td>
                                                    <td>Valid GATE score</td>
                                                </tr>
                                                <tr>
                                                    <td rowSpan="1">
                                                        <b>
                                                            Humanities and
                                                            Social Sciences
                                                        </b>
                                                    </td>
                                                    <td>
                                                        <b>11</b>
                                                    </td>
                                                    <td>
                                                        Master’s
                                                        degree/dual-degree or
                                                        equivalent in a relevant
                                                        discipline
                                                    </td>
                                                    <td>
                                                        Qualifying UGC–NET or
                                                        JRF/CSIR-JRF/GATE score
                                                        or equivalent
                                                        qualification, tenable
                                                        for the current year in
                                                        the relevant area or an
                                                        international-level post
                                                        graduate admission
                                                        examination such as GRE.
                                                        <br />
                                                        <br />
                                                        Candidates with only a
                                                        GRE (or equivalent
                                                        international-level post
                                                        graduate admission
                                                        examination) score are
                                                        not eligible for HTRA.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="4">
                                                        Note: A valid GATE score
                                                        or
                                                        UGC/CSIR-NET/INSPIRE/NBHM
                                                        qualification etc. is
                                                        not required in the case
                                                        of candidates applying
                                                        under the external
                                                        category
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="4">
                                                        # Candidates with
                                                        Educational
                                                        Qualifications as
                                                        mentioned in the S.No.
                                                        3,4,5,8,9,10 will be
                                                        considered for Direct
                                                        Ph.D.
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table> */}
                                        <p>
                                            All International MS/PhD applicants must satisfy the following criteria :
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                {" "}
                                                CGPA 6.5 or above
                                            </li>
                                            <li>
                                                {" "}
                                                Proof of English Proficiency – if medium of instruction at the undergraduate level is not English
                                            </li>
                                        </ul>
                                        <p>In addition, the following criteria need to be satisfied for various programs as listed below.</p>
                                        
                                      
                                      
                                        <ul className="myulcustarrow">
                                            <p>
                                                <b>Ph.D. in Engineering</b>
                                            </p>
                                            <li>
                                                {" "}
                                                A Master’s degree in
                                                Engineering/Technology or a
                                                Master’s degree by Research in
                                                Engineering/Technology with a
                                                good academic record or a
                                                five-year integrated Masters/
                                                Dual Degree in
                                                Engineering/Technology.
                                            </li>
                                            <p className="text-center">(or)</p>
                                            <li>
                                                {" "}
                                                A Master’s degree in Sciences
                                                with a good academic record and
                                                of exceptional merit in the
                                                relevant Engineering discipline.
                                            </li>
                                             <p className="text-center">(or)</p>
                                            <li>
                                                {" "}
                                                Candidates with a five-year
                                                integrated BS+MS degree from any
                                                Centrally Funded Technical
                                                Institute.
                                            </li>
                                        </ul>
                                        <ul className="myulcustarrow">
                                            <p>
                                                <b>Ph.D. in Sciences</b>
                                            </p>
                                            <li>
                                                {" "}
                                                Master’s degree in Sciences with
                                                a good academic record.
                                            </li>
                                             <p className="text-center">(or)</p>
                                            <li>
                                                {" "}
                                                Master’s degree holders in
                                                Engineering/Technology and
                                                Master of Science (Research) or
                                                a five-year integrated Masters/
                                                Dual Degree in
                                                Engineering/Technology.
                                            </li>
                                            <p className="text-center">(or)</p>
                                            <li>
                                                {" "}
                                                Candidates with a five-year
                                                integrated BS+MS degree from any
                                                Centrally Funded Technical
                                                Institute.
                                            </li>
                                        </ul>
                                        <p>
                                            <b>
                                                Ph.D. in Humanities and Social
                                                Sciences
                                            </b>
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                {" "}
                                                Master's degree in an eligible
                                                discipline with a good academic
                                                record.
                                            </li>
                                        </ul>

                                        <p>
                                            <b>MS (Research) applicants</b>
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                {" "}
                                                Candidates with a Bachelor's
                                                degree in Engineering/Technology
                                                or a Master’s Degree (M.Sc / MCA
                                                etc.) in the relevant
                                                discipline.
                                            </li>
                                        </ul>

                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Fiancial  Assistance*/}

                        <div>
                            {financialOpen && (
                                <Fade in={financialOpen}>
                                    <div>
                                        <h4 className="mb-4">Financial Assistance</h4>
                                        <p>
                                            <b>
                                            Applicants can explore the following links for financial assistance.
                                            </b>
                                        </p>
                                        <ul className="myulcustarrow">
                                           {/*} <li>
                                                Study in India - (SII) -{" "}
                                                <a
                                                    href="https://www.studyinindia.gov.in"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <b>
                                                        https://www.studyinindia.gov.in
                                                    </b>
                                                </a>
                                            </li>
                                            <li>
                                                Indian Council for Cultural
                                                Relations - (ICCR) -{" "}
                                                <a
                                                    href="http://a2ascholarships.iccr.gov.in"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <b>
                                                        http://a2ascholarships.iccr.gov.in
                                                    </b>
                                                </a>
                                            </li>*/}
                                            <li>
                                            Study in India{" "}
                                                <a
                                                    href="https://studyinindia.gov.in/"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <b>https://studyinindia.gov.in/</b>
                                                </a>
                                            </li>
                                            {/* <li>
                                                For students from Nepal: Dr.
                                                Homi Jahangir Bhaba Scholarship
                                                for ME/M.Tech students (HJBSS){" "}
                                                <a
                                                    href="https://www.cgibirgunj.gov.in/page/advertisement-of-dr-homi-jahangir-bhabha-scholarship-scheme-2023-2024/"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <b>
                                                        https://www.cgibirgunj.gov.in/page/advertisement-of-dr-homi-jahangir-bhabha-scholarship-scheme-2023-2024/
                                                    </b>
                                                </a>
                                            </li> */}

                                            {/* <li>
                                                ASEM-DUO Fellowship Programme -{" "}
                                                <a
                                                    href="http://www.asemduo.org"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <b>
                                                        http://www.asemduo.org
                                                    </b>
                                                </a>
                                            </li> */}
                                            
                                        </ul>
                                        {/* <p>
                                            <b>Other Useful links</b>
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                ASEAN DIA Login Portal -{" "}
                                                <a
                                                    href="https://ecampus.iitd.ac.in/ASEAN/login"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <b>
                                                        https://ecampus.iitd.ac.in/ASEAN/login
                                                    </b>
                                                </a>
                                            </li>
                                            <li>
                                                Visa application portal -{" "}
                                                <a
                                                    href="https://indianvisaonline.gov.in/"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <b>
                                                        https://indianvisaonline.gov.in
                                                    </b>
                                                </a>
                                            </li>
                                            <li>
                                                ASEM-DUO Fellowship Programme -{" "}
                                                <a
                                                    href="http://www.asemduo.org"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <b>
                                                        http://www.asemduo.org
                                                    </b>
                                                </a>
                                            </li>
                                        </ul> */}
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Section*/}

                        {/* <div>
                            {sectionOpen && (
                                <Fade in={sectionOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Selection Procedure
                                        </h4>
                                        <p>
                                            The selection committee will call
                                            eligible candidates based on the
                                            minimum eligibility requirements and
                                            additional screening criteria for a
                                            written test (if any) and interview.
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div> */}

                        {/*Documents*/}

                        {/* <div>
                            {documentsOpen && (
                                <Fade in={documentsOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Original Documents to be submitted
                                            for Verification:
                                        </h4>
                                        <p>
                                            <b>
                                                At the time of Interview and/or
                                                Written Test:
                                            </b>
                                        </p>
                                        <p>
                                            Self-attested copies of the
                                            following documents must be
                                            submitted at the time of interview
                                            and/or written test.
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>Copy of application</li>
                                            <li>
                                                Degree certificates /
                                                Provisionals / Course completion
                                                certificates / Grade Cards /
                                                Marksheets of all the degrees
                                                obtained.
                                            </li>
                                            <li>
                                                Community Certificate in the
                                                case of SC/ST/OBC-NCL/EWS
                                                candidates issued by the
                                                Competent Authority in the
                                                prescribed GoI format.
                                            </li>
                                            <li>
                                                Authorized Doctor’s Certificate
                                                with disability descriptions in
                                                the case of Person with Disabled
                                                (PwD) candidates.
                                            </li>
                                            <li>
                                                Copy of GATE score or
                                                CSIR-UGC-JRF/LS/NET/DAE-JEST or
                                                any other fellowship award.
                                            </li>
                                        </ul>
                                        <p>
                                            Important: Please note that the
                                            originals of all the above
                                            certificates should be produced at
                                            the time of physical verification.
                                        </p>
                                        <p>
                                            <b>At the time of Admission:</b>
                                        </p>
                                        <p>
                                            Self-attested copies of the
                                            following documents must be
                                            submitted at the time of admission /
                                            registration
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>Offer of admission.</li>
                                            <li>
                                                Birth Certificate / SSC / SSLC
                                                certifcate as proof of Name and
                                                Date of birth
                                            </li>
                                            <li>
                                                Any valid government ID proof
                                                such as Aadhaar, PAN, Passport,
                                                Driving License, etc.
                                            </li>
                                            <li>
                                                Degree certificates /
                                                Provisionals / Course completion
                                                certificates / Grade Cards /
                                                Marksheets of all the degrees
                                                obtained.
                                            </li>
                                            <li>
                                                Community Certificate in the
                                                case of SC/ST/OBC-NCL/EWS
                                                candidates issued by the
                                                Competent Authority in the
                                                prescribed GoI format.
                                            </li>
                                            <li>
                                                Degree certificates /
                                                Provisionals / Course completion
                                                certificates / Grade Cards /
                                                Marksheets of all the degrees
                                                obtained.
                                            </li>
                                            <li>
                                                Candidates admitted under
                                                External category must also
                                                produce:
                                                <ul>
                                                    <li>
                                                        No Objection Certificate
                                                        for using Research
                                                        Facilities on the
                                                        employer’s premises.
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/6.docx"
                                                            target="_blank"
                                                            className="c-link"
                                                        >
                                                            (Link)
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        Consent of Co-supervisor
                                                        from the parent
                                                        organization in case of
                                                        external candidates.
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/7.docx"
                                                            target="_blank"
                                                            className="c-link"
                                                        >
                                                            (Link)
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        Relieving order from the
                                                        employer in the case of
                                                        fulltime candidates, if
                                                        employed.{" "}
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/8.docx"
                                                            target="_blank"
                                                            className="c-link"
                                                        >
                                                            (Link)
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                        <p>
                                            Important: Please note that the
                                            originals of all the above
                                            certificates should be produced at
                                            the time of physical verification.
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div> */}

                        {/*Fees*/}

                        <div>
                            {feesOpen && (
                                <Fade in={feesOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Fees and Deposits
                                        </h4>
                                        <p>
                                        	The tuition and hostel fees for the current semester can be found by clicking on the following{" "}
                                            <Link
                                                to="/fee-structure"
                                                className="c-link"
                                            >
                                                link
                                            </Link> Please note that an international student fee of INR 50,000/year will be applicable. 
                                        
                                        </p>

                                        <p>	Please note that the fee is subject to revision for the next semester.</p>
                                    </div>
                                </Fade>
                            )}
                        </div>
                        {/*Apply Online*/}

                        <div>
                            {applyonlineOpen && (
                                <Fade in={applyonlineOpen}>
                                    <div>
                                        <h4 className="mb-4">Apply Online</h4>
                                        <p>
                                            <b>MS Foreign application Live URL</b> :{" "}
                                            <Link
                                               to="https://iittp.plumerp.co.in/prod/iittirupati/msapplication"
                                              
                                                target="_blank"
                                                className="c-link" >
                                                <b>
                                                    Click here
                                                </b>
                                            </Link>
                                        </p>

                                        <p>
                                            <b>PhD Foreign application Live URL</b> :{" "}
                                            <Link
                                               to="https://iittp.plumerp.co.in/prod/iittirupati/phdapplication"
                                               target="_blank"
                                              
                                                className="c-link" >
                                                <b>
                                                Click here
                                                </b>
                                            </Link>
                                        </p>
                                        
                                    </div>
                                </Fade>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default MsPhdInternational_admissionEle;
